<template lang="pug">
  table.table.table-bordered.table_document
    tr
      td Дата проведения операции
      td
        span(v-if='data.body.content.operation_date') {{data.body.content.operation_date | date}}
        span(v-if='!data.body.content.operation_date') —
    tr
      td Название операции
      td {{formatAnswer(data.body.content.operation_name, 2)}}
    tr
      td Диагноз до операции
      td {{formatAnswer(data.body.content.before_operation_diagnosis, 2)}}
    tr
      td Диагноз после операции
      td {{formatAnswer(data.body.content.after_operation_diagnosis, 2)}}
    tr
      td Время начала операции
      td {{formatAnswer(data.body.content.operation_start_time, 2)}}
    tr
      td Время окончания операции
      td {{formatAnswer(data.body.content.operation_stop_time, 2)}}
    tr
      td Описание операции
      td {{formatAnswer(data.body.content.description, 2)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
